import { FC, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import {
  EventSignatureStatusCell,
  EventSignatureStatusCellProps,
} from '../../../components/event-signature-status-cell';

export type TableTdProps = { className?: string; value: ReactNode | string };

export const SIGNATURE_STATUS_COLUMN_CLASS = 'w-[1%] max-w-[148px] whitespace-nowrap pr-8';

export const Td: FC<TableTdProps> = ({ value, className }) => (
  <td className={twMerge('max-w-[300px] px-4 py-6', className)}>
    <span className="block truncate text-sm font-[450] text-gray-700">{value}</span>
  </td>
);

export const SignatureStatusTd: FC<{ value: ReactNode }> = ({ value }) => (
  <td className={twMerge('px-4 py-6', SIGNATURE_STATUS_COLUMN_CLASS)}>
    <span className="inline-block text-sm font-[450] text-gray-700">{value}</span>
  </td>
);

export const EventSignatureStatusTableCell: FC<EventSignatureStatusCellProps> = ({
  signatureSignedCount,
  signatureStatus,
  signatureTotalCount,
}) => (
  <SignatureStatusTd
    value={
      <EventSignatureStatusCell
        signatureSignedCount={signatureSignedCount}
        signatureStatus={signatureStatus}
        signatureTotalCount={signatureTotalCount}
      />
    }
  />
);
